import React from 'react'
import RoundedButton from '@app/ui/rounded-button/RoundedButton'
import { View } from 'react-native'
import { useAxios } from '@common/hooks/useAxios'
import useUser from '@common/hooks/useUser'

interface RefreshCoursesProps {
  onRefreshingChange?: (refreshing: boolean) => void
}

const RefreshCourses = ({ onRefreshingChange }: RefreshCoursesProps) => {
  const user = useUser()
  const axios = useAxios('/courses')

  const refreshCourses = async () => {
    onRefreshingChange?.(true)
    try {
      await axios.post('/clubsAndCourses')
    } catch (error) {
      onRefreshingChange?.(false)
      throw error
    }
  }

  if (!user?.isAdmin) return null

  return (
    <View
      style={{
        alignItems: 'flex-end',
      }}
    >
      <RoundedButton title="Update courses" onPress={refreshCourses} />
    </View>
  )
}

export default RefreshCourses
